<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('service_exclusive_table')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">
        Create Service Categories
      </h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
        >
        </base-input>

        <div class="mb-4">
          <div
            class="text-sm text-gray-600 font-medium px-2 py-1 my-1 border rounded bg-gray-100 inline-block"
          >
            Recommended Size: 400 × 400px
          </div>
          <FileUploader
            v-show="!image"
            :image="image"
            :onSuccess="handleSuccess"
          />
        </div>

        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
        <img v-if="image" :src="image" ref="cover" />
        <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        />

        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="isScrollSF">
            <p>
              <strong> <p class="col-blk">Scroll to Service Form.</p></strong>
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-3" v-model="isURL">
            <p>
              <strong> <p class="col-blk">Add URL</p></strong>
            </p></b-form-checkbox
          >
        </div>
        <template v-if="isURL">
          <div class="mb-2">
            <b-form-input
              class="mb-3"
              alternative
              name="URL"
              :rules="{ required: true }"
              placeholder="Enter your custom URL"
              v-model="url"
            >
              <p>
                <strong> <p class="col-blk">Add URL</p></strong>
              </p></b-form-input
            >
          </div>
        </template> -->
        <div class="mb-5">
          <p class="font-semibold text-lg">Membership Discounts</p>
          <template v-for="(item, index) in get_all_membership">
            <label>{{ item.name }}</label>
            <b-input
              v-model="memberDisc[item.name]"
              placeholder="Enter Discount"
              type="number"
              class="w-60 mb-5"
            />
          </template>
        </div>
        <div class="mb-2 w-1/3">
          <label for="campaign">Campaigns:</label>
          <multiselect
            v-model="selectedCampaigns"
            :options="getCampaignOptions()"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="false"
            placeholder="Select Campaign"
            track-by="value"
            label="label"
          ></multiselect>
        </div>

        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-3" v-model="showOnCampaign">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on campaign.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      image: null,
      coverImage: null,
      isScrollSF: false,
      isURL: false,
      selectedCampaigns: [],
      campaignOptions: [],
      url: "",
      body: "",
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      msg: {},
      memberDisc: {},
      // showOnCampaign: false,
    };
  },

  methods: {
    getCampaignOptions() {
      return this.campaignHome && this.campaignHome.result
        ? this.campaignHome.result.map((campaign) => ({
            label: campaign.heading,
            value: campaign._id,
          }))
        : [];
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("title", this.title);
      data.append("icon", this.coverImage);
      data.append("description", this.body);
      data.append("isScrollSF", this.isScrollSF);
      data.append("isURL", this.isURL);
      data.append(
        "selectedCampaigns",
        this.selectedCampaigns.map((campaign) => campaign.value)
      );
      // data.append("showOnCampaign", this.showOnCampaign);
      if (this.isURL) {
        data.append("link", this.url);
      }
      data.append("membershipDisc", JSON.stringify(this.memberDisc));

      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const blogdata = await this.$store.dispatch("services/create", data);
        // if (blogdata.code == 200) {
        this.$router.push({ name: "service_exclusive_table" });
        this.$swal.fire({
          title: "Success!",
          text: "Your service has been successfully added",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    campaignHome() {
      return this.$store.state.campaignPageBanner.campaignHome || {};
    },
  },
  async mounted() {
    await this.get_all_membership.forEach((element, index) => {
      this.memberDisc[element.name] = 0;
      // this.discErr[element.name] = false;
    });
    await this.$store.dispatch("campaignPageBanner/get_campaignhome");
  },
  watch: {
    isScrollSF() {
      if (this.isScrollSF) this.isURL = false;
    },
    isURL() {
      if (this.isURL) this.isScrollSF = false;
    },
  },
};
</script>
